<template>
    <v-container fluid>
        <v-row>
            <v-col cols="6">
                <date-range-picker
                    ref="picker"
                    v-model="dateRange"
                    @update="updateMessagesList"
                    :locale-data="localeData"
                >
                    <template #input="picker" style="display: block;">
                        <v-text-field 
                            label="Perioada"
                            :value="selectedPeriod"
                            :dummy="picker"
                            hide-details
                            prepend-icon="mdi-calendar"
                            dense
                        >
                        </v-text-field>
                    </template>
                </date-range-picker>
            </v-col>
            <v-col cols="6">

            </v-col>
        </v-row>
          Mesaje
    </v-container>
</template>
<script>

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    name: 'Messages',
    components: { DateRangePicker },
    data: () => ({
            dateRange: {
                startDate: new Date().toISOString().substr(0, 10), 
                endDate: new Date().toISOString().substr(0, 10)
            },
            localeData: {
                format: 'yyyy-mm-dd',
            },
        tableLoading: true,
        tableLoadingText: "Se încarcă... Te rog așteaptă",

    }),
    computed:{
        selectedPeriod(){
            return this.$moment(this.dateRange.startDate).format('YYYY-MM-DD') + ' - ' + this.$moment(this.dateRange.endDate).format('YYYY-MM-DD');
        },
    },
    methods: {
        updateMessagesList(){
            this.getMessages();
        },
        getMessages(){
            this.tableLoading = true;
            this.$store.dispatch('messages/getMessages',{
                startDate: this.$moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                endDate: this.$moment(this.dateRange.endDate).format('YYYY-MM-DD'),
            }).then(()=>{
                this.tableLoading = false;
            })
        }
    }
}
</script>